//
import Card from './Card';
import Switch from './Switch';
import Paper from './Paper';
import Select from './Select';
import Input from './Input';
import Table from './Table';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import TextField from './TextField';
import Autocomplete from './Autocomplete';
import DataGrid from './DataGrid';
import Link from './Link';
import Container from './Container';

// remember to import this file in index.js

export default function ComponentsOverrides(theme) {
  return Object.assign(
    Card(theme),
    Switch(theme),
    Table(theme),
    Input(theme),
    Paper(theme),
    Select(theme),
    Button(theme),
    Tooltip(theme),
    Backdrop(theme),
    Typography(theme),
    TextField(theme),
    Autocomplete(theme),
    DataGrid(theme),
    Link(theme),
    Container(theme)
  );
}
